import { render, staticRenderFns } from "./NetizenLessonView.vue?vue&type=template&id=3dc90c98&"
import script from "./NetizenLessonView.vue?vue&type=script&lang=js&"
export * from "./NetizenLessonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports